import type { User } from '@supabase/supabase-js';

/**
 * Anzeigename eines Nutzers aus den Auth-Metadaten.
 *
 * Die Reihenfolge spiegelt handle_new_user (Migration 171): der app-eigene
 * Key display_name gewinnt, danach kommen die Provider-Keys. GoTrue
 * schreibt bei OAuth-Anmeldungen full_name und name, aber nie display_name
 * - ohne diese Kette faellt ein Google- oder Apple-Nutzer hier auf den
 * E-Mail-Lokalteil zurueck ("max.mustermann"), obwohl sein Name in den
 * Metadaten steht.
 */
export function getMetadataDisplayName(user: User | null | undefined): string | null {
  const meta = user?.user_metadata as Record<string, unknown> | undefined;

  for (const key of ['display_name', 'full_name', 'name']) {
    const value = meta?.[key];
    if (typeof value === 'string' && value.trim()) return value.trim();
  }

  return null;
}

/**
 * Anzeigename mit den bisherigen Fallbacks: E-Mail-Lokalteil, dann 'User'.
 */
export function getUserDisplayName(
  user: User | null | undefined,
  fallback = 'User',
): string {
  return getMetadataDisplayName(user) || user?.email?.split('@')[0] || fallback;
}
